// helpers/rutaProductos.js
import axios from "axios";

// Base URL (usa .env si está, sino el back de San Pancracio)
const RAW_BASE_URL = import.meta.env?.VITE_API_URL || "https://backsanpancracio.us-3.evennode.com";
const BASE_URL = RAW_BASE_URL.replace(/\/+$/, ""); // sin slash final

const API = axios.create({ baseURL: BASE_URL });

// arma paths sin slash inicial
const p = (s) => String(s || "").replace(/^\/+/, "");

// headers con token si existe
const auth = () => {
  const token = localStorage.getItem("token") || "";
  return token ? { headers: { token } } : {};
};

// DEBUG opcional
const debugUrl = (url) => console.log("👉 URL:", API.getUri({ url }));

// --------- PRODUCTOS ---------
export const getProductos = async () => {
  const url = p("productos");
  debugUrl(url);
  const { data } = await API.get(url, auth());
  // Normaliza: { ok, productos:[...] } o array directo
  return Array.isArray(data?.productos) ? data.productos : (Array.isArray(data) ? data : []);
};

export const getProductoById = async (id) => {
  const url = p(`productos/${id}`);
  debugUrl(url);
  const { data } = await API.get(url, auth());
  return data; // { ok:true, producto:{...} }
};

export const postProducto = async (productoData) => {
  const url = p("productos");
  debugUrl(url);
  const { data } = await API.post(url, productoData, auth());
  return data; // { ok:true, producto:{...} }
};

export const putProducto = async (id, productoData) => {
  const url = p(`productos/${id}`);
  debugUrl(url);
  const { data } = await API.put(url, productoData, auth());
  return data; // { ok:true, producto:{...} }
};

export const deleteProducto = async (id) => {
  const url = p(`productos/${id}`);
  debugUrl(url);
  const { data } = await API.delete(url, auth());
  return data; // { ok:true, producto:{...} }
};
